import React from 'react';
import Button from 'sushiweb/Button';
import styled from 'styled-components';

const ButtonWrapper = styled(Button)`
  width: ${(props) => (props.isMaxWidth ? '100%' : '')};
  span {
    font-size: 14px;
    font-weight: 500;
  }
`;

export const ButtonBox = ({
  title = '',
  size = 'small',
  outline = true,
  color = 'green',
  onClick,
  isDisabled = false,
  isMaxWidth = false,
  loading = false,
}) => {
  let ButtonTemplate = (
    <div className='btn'>
      <ButtonWrapper
        loading={loading}
        disabled={isDisabled}
        size={size}
        btnColor={color}
        appearance={`${outline ? 'outline' : 'solid'}`}
        onClick={onClick}
        isMaxWidth={isMaxWidth}
      >
        {title}
      </ButtonWrapper>
    </div>
  );
  return ButtonTemplate;
};
